import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Avatar from 'react-avatar';
import Button from '../../../../components/Button';
import ProfileBanner from '../../../../assets/app-only/images/profile-banner.png';
import { Modules } from '../../../../enums';

interface TopSectionProps {
  email: string;
  fullName: string;
  manager: any;
  roles: any[];
}

const TopSection: React.FC<TopSectionProps> = ({ email, fullName, roles, manager }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToDashboardClick = () => {
    navigate(Modules.home);
  };

  return (
    <div className="card mb-6">
      <div className="user-profile-header-banner">
        <img
          src={ProfileBanner}
          alt={t('users.profile.pageTexts.bannerImgAlt')}
          className="rounded-top"
        />
      </div>
      <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-5">
        <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
          <div className="d-block h-auto ms-0 ms-sm-5 rounded-4 user-profile-img">
            <Avatar
              name={fullName ?? '-'}
              className="profile-avatar"
              size="110"
              textSizeRatio={1}
              maxInitials={2}
            />
          </div>
        </div>
        <div className="flex-grow-1 mt-4 mt-sm-12">
          <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-5 flex-md-row flex-column gap-6">
            <div className="user-profile-info">
              <h4 className="mb-2">{fullName || '-'}</h4>
              <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-4">
                <li className="list-inline-item">
                  <i className="ri-mail-line me-2 ri-24px"></i>
                  <span className="fw-medium">{email || '-'}</span>
                </li>
                <li className="list-inline-item">
                  <i className="ri-shield-user-line me-2 ri-24px"></i>
                  <span className="fw-medium">
                    {t('users.profile.pageTexts.assignedRole')}{' '}
                    {roles && roles.length ? roles[0]?.name : '-'}
                  </span>
                </li>
                <li className="list-inline-item">
                  <i className="ri-user-star-line me-2 ri-22px"></i>
                  <span className="fw-medium">
                    {t('users.profile.pageTexts.manager')}:{' '}
                    {manager?.name ?? t('users.profile.pageTexts.notAssigned')}
                  </span>
                </li>
              </ul>
            </div>
            <Button
              text={t('users.profile.pageTexts.goToDashboardButton')}
              onClick={handleGoToDashboardClick}
              className="btn btn-primary mt-md-3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
